let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("e1cuZ"), load("6kXh6"), load("hvHZS")]).then(() => parcelRequire('5QLLH'));